<script lang="ts" setup>
import { computed } from "vue";
import { SlimOrder } from "@/types/order/Order";
import BeginnerTag from "@/components/atoms/other/BeginnerTag.vue";

const props = defineProps<{
  order: SlimOrder;
  orderService?: string | null;
}>();

const isWelcomeNoExpInNursingCare = computed(() => {
  // 1 = 'welcome_no_exp_in_nursing_care'
  return props.order.recommendationPoints.includes(1);
});

const isWelcomeCaitechBeginners = computed(() => {
  // 2 = 'welcome_caitech_beginners'
  return props.order.recommendationPoints.includes(2);
});
</script>

<template>
  <div class="text-size-14">
    <div class="w-full d-flex items-center justify-content-between">
      <div class="beginner-order-label">
        <BeginnerTag
          v-if="isWelcomeNoExpInNursingCare"
          label="介護未経験者歓迎"
          class="text-primary-dark bg-welcome-no-exp-in-nursing-care"
          data-testid="welcome-no-exp-in-nursing-care-label"
        />
        <BeginnerTag
          v-if="isWelcomeCaitechBeginners"
          label="カイテク初心者歓迎"
          class="text-primary-dark bg-welcome-caitech-beginners"
          data-testid="welcome-caitech-beginners-label"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bg-welcome-no-exp-in-nursing-care {
  background-color: $welcome-no-exp-in-nursing-care;
}

.bg-welcome-caitech-beginners {
  background-color: $welcome-caitech-beginners;
}

.beginner-order-label {
  display: flex;
  gap: 4px;
  margin-top: 8px;
}
</style>
